import React from "react";
const WidthIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 2h1v15H1zM12.27 6.81l-.37.37a.2.2 0 0 0 0 .28L13.47 9H5.53L7.1 7.47a.2.2 0 0 0 0-.28l-.37-.37a.2.2 0 0 0-.28 0L3.76 9.5l2.69 2.69a.2.2 0 0 0 .28 0l.37-.37a.2.2 0 0 0 0-.28L5.53 10h7.93l-1.56 1.53a.2.2 0 0 0 0 .28l.37.37a.2.2 0 0 0 .28 0l2.69-2.68-2.69-2.69a.2.2 0 0 0-.28 0zM17 2h1v15h-1z" }));
var WidthIcon_default = WidthIcon;
export {
  WidthIcon_default as default
};
//# sourceMappingURL=WidthIcon.js.map
